(function () {
  function scroller() {
    return document.querySelector('.page-wrapper') || document.scrollingElement || window;
  }

  // Horizon nests every section inside a per-group wrapper inside the scroll
  // container. Returns the ancestor of el that is a direct child of the scroller.
  function topLevel(el, sc) {
    var node = el;
    while (node && node.parentElement) {
      if (node.parentElement === sc || node.parentElement === document.body) return node;
      node = node.parentElement;
    }
    return null;
  }

  function init() {
    var hd = document.querySelector('[id^="pg-hd-"]');
    if (!hd || hd.dataset.pgInit === '1') return;
    hd.dataset.pgInit = '1';
    hd.style.position = 'relative';

    var sc = scroller();
    var group = topLevel(hd, sc);

    // Lift the utility bar out of the sticky group so it scrolls away as ordinary
    // content. Animating its height instead would reflow the page every frame.
    var util = document.querySelector('[id^="u-"]');
    var utilSection = util ? util.closest('.shopify-section') : null;
    if (utilSection && group && group.parentElement && group.contains(utilSection)) {
      group.parentElement.insertBefore(utilSection, group);
    }

    if (group) {
      group.style.position = 'sticky';
      group.style.top = '0px';
      group.style.zIndex = '60';
    }

    var scrim = document.getElementById('pg-scrim');
    var openKey = null;
    function desktop() { return window.matchMedia('(min-width: 901px)').matches; }

    function closeAll() {
      if (openKey === null) return;
      hd.querySelectorAll('.pgh-mg.is-open').forEach(function (m) { m.classList.remove('is-open'); });
      hd.querySelectorAll('.pgh-nav > li.is-open').forEach(function (l) {
        l.classList.remove('is-open');
        var b = l.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      hd.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      openKey = null;
    }

    function open(key) {
      if (openKey === key) return;
      var li = hd.querySelector('.pgh-nav > li[data-m="' + key + '"]');
      var mega = hd.querySelector('.pgh-mg[data-p="' + key + '"]');
      if (!li || !mega) return;
      hd.querySelectorAll('.pgh-mg.is-open').forEach(function (m) { if (m !== mega) m.classList.remove('is-open'); });
      hd.querySelectorAll('.pgh-nav > li.is-open').forEach(function (l) {
        if (l !== li) {
          l.classList.remove('is-open');
          var b = l.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
      hd.classList.add('is-open');
      li.classList.add('is-open');
      mega.classList.add('is-open');
      var btn = li.querySelector('button'); if (btn) btn.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-open');
      openKey = key;
    }

    hd.addEventListener('mouseover', function (e) {
      if (!desktop() || hd.classList.contains('drawer-open')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.pgh-mg')) return;
      var li = t.closest('.pgh-nav > li');
      if (li) {
        var key = li.getAttribute('data-m');
        if (key) { open(key); } else { closeAll(); }
        return;
      }
      if (t.closest('.pgh-nav')) return;
      if (t.closest('.pgh-bar')) closeAll();
    });

    hd.addEventListener('mouseleave', function () { if (desktop()) closeAll(); });

    hd.querySelectorAll('.pgh-nav > li[data-m] > button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var key = btn.parentElement.getAttribute('data-m');
        if (openKey === key) { closeAll(); } else { open(key); }
      });
    });

    if (scrim) scrim.addEventListener('click', closeAll);

    var burger = hd.querySelector('.pgh-burger');
    var drawer = hd.querySelector('.pgh-drawer');
    function closeDrawer() {
      hd.classList.remove('drawer-open');
      document.body.style.overflow = '';
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
    function toggleDrawer() {
      var on = hd.classList.toggle('drawer-open');
      document.body.style.overflow = on ? 'hidden' : '';
      if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    if (burger && drawer) {
      burger.addEventListener('click', function (e) { e.preventDefault(); toggleDrawer(); });
      drawer.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) closeDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeDrawer(); }
    });
    window.addEventListener('resize', function () { if (desktop()) closeDrawer(); });

    var ticking = false;
    function pos() { return sc === window ? window.scrollY : sc.scrollTop; }
    function paint() {
      ticking = false;
      hd.classList.toggle('is-shrunk', pos() > 4);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(paint);
    }
    sc.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
